import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('post', `/api/roundtables/${id}/send_evaluations`, payload);


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/sendEvaluations.js